export function setUIPluginInstallations(state, installations) {
  const items = Array.isArray(installations) ? installations : []
  state.value.uiPluginInstallations = items
  if (state.value.installationsReady === true) return

  if (typeof performance !== 'undefined' && typeof performance.mark === 'function') {
    performance.mark('aime:installations-ready')
  }
  state.value.installationsReady = true
}
